import { atom } from "jotai";
import { SubmitAccessibility } from "common/apis";
import { atomWithLocalStorage } from "common/storage";

export const emailCheckWelcomeNameAtom = atom("");
export const emailAtom = atom("");
export const emailValidAtom = atom(false);
export const passwordAtom = atom("");
export const submitAccessibilityAtom = atom<SubmitAccessibility>({
  userId: 0,
  ability: "",
  how_do_you_hear_about_us_ids: "",
  accessibility_need_selection: "",
  makeDisabilityVisibleValue: false,
  accessibilityFeatureRequestTagsValue: "",
});
export const registeredUserIdAtom = atom(0);
export const drawerMenuOpenAtom = atom(false);
export const savedFiltersAppliedAtom = atom(false);
export const resetForgotPasswordCodeAtom = atom("");
export const messageForLoginModalAtom = atom("");
export const actionToPerformAfterLoginAtom = atom("");
export const actionToPerformValueAfterLoginAtom = atom("");
export const onboardingCompletedAtom = atomWithLocalStorage(
  "onboardingCompletedAtom",
  false,
);
export const onboardingScreenAtom = atom(false);
export const onboardingCurrentScreenAtom = atom(0);
